// extracted by mini-css-extract-plugin
export default {"container":"Card_container__py8fw","content":"Card_content__Kg2Nx","title":"Card_title__ipN7g","subtitle":"Card_subtitle__jTOhf"};